import { render, staticRenderFns } from "./ProductFinder.vue?vue&type=template&id=4c8e9f80&scoped=true&"
import script from "./ProductFinder.vue?vue&type=script&lang=js&"
export * from "./ProductFinder.vue?vue&type=script&lang=js&"
import style0 from "./ProductFinder.vue?vue&type=style&index=0&id=4c8e9f80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8e9f80",
  null
  
)

export default component.exports